<div class="flex flex-auto">
    <p-autoComplete #adjusterSearchComponent appendTo="body" [(ngModel)]="selectedAdjuster" [suggestions]="adjusterSuggestions" 
                        (completeMethod)="adjusterSearch($event)" [placeholder]="placeholder" optionLabel="name"
                        class="m-2 flex flex-auto" styleClass="flex flex-auto" inputStyleClass="flex flex-auto" (onSelect)="selectAdjuster($event)">
        <ng-template let-adjuster pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" >{{ adjuster.firstName }} {{adjuster.lastName}} </div>
            </div>
        </ng-template>
    </p-autoComplete>
</div>